import { MicrositioEnum } from '../../../utils/constanst';


const propLoading = {
    txtMsg: 'Cargando...',
    active: false
} as IModalProps


const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '13px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '13px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            boxShadow: 0,
            "text-align-last": "left",
            '&:hover': {
                border: '0 !important',
                "outline-style": "none !important",
                "border-left": "2px solid #008964 !important",
                "border-bottom": "1px solid #bae6da !important",
                "border-top": "1px solid #bae6da !important",
                "border-right": "1px solid #bae6da !important",
            },
            selectProps: {
                backgroundColor: "#008964",
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const BuildDataOportunity = ({ data, src }: IBuildData_IHCRAutoExpedibleContenido_Props) => {
    let dataOportunity: INotificationOportunityMicrositio = {
        TipoId: parseInt(data.identificationType),
        Identificacion: data.identification,
        Nombre: `${data.firstName1} ${data.firstName2}`,
        Apellido: `${data.lastName1} ${data.lastName2}`,
        Email: data.mail,
        Celular: data.phoneNumber,
        Source: src ?? '',
        Nombres: `${data.firstName1} ${data.firstName2}`,
        Micrositio: MicrositioEnum.IncendioAutoExpedibleContenido
    }

    return dataOportunity;
}

const BuildDataNotification = ({ data, src }: IBuildData_IHCRAutoExpedibleContenido_Props) => {
    const temp = {
        "TipoId": data.identificationType,
        "Identificacion": data.identification,
        "Nombre": `${data.firstName1} ${data.firstName2}`,
        "Apellido": `${data.lastName1} ${data.lastName2}`,
        "Celular": data.phoneNumber,
        "Email": data.mail,
        "Micrositio": MicrositioEnum.IncendioAutoExpedibleContenido,
        "IdPoliza": 0,
        "Source": src,
        "IdProductor": 0,
        "IdPlan": 0
    }
    return temp;
}

export {
    customStyles,
    BuildDataOportunity,
    BuildDataNotification,
    propLoading
};